<template>
  <div class="content">
    <ul id="itemList" class="flex-container">
      <li>
        <div class="image">
          <img src="../assets/package-1.png">
        </div>
        <div class="description">
          <p>４袋入り ¥1,120(税込み)<br class="sp"> <a target="_blank" href="https://nagasakigoto.net/products/detail/244">ご購入<span>はこちらから</span></a></p>
        </div>
      </li>
      <li>
        <div class="image">
          <img src="../assets/package-4.png">
        </div>
        <div class="description type2">
          <p>10袋入り ¥2,800(税込み)<br class="sp"> <a target="_blank" href="https://nagasakigoto.net/products/detail/245">ご購入<span>はこちらから</span></a></p>
        </div>
      </li>
    </ul>
    <YasashikuteBox/>
  </div>
</template>

<script>
import YasashikuteBox from './YasashikuteBox.vue'
export default {
  name: 'Shop',
  components: {
    YasashikuteBox
  }
}
</script>

<style scoped>
  li{
    list-style: none;
    margin: 0;
    padding: 0;
    position: relative;
    max-width:50%;
    font-size: 18px;
    font-weight: bold;
    font-size: 18px;
  }
  ul{
    margin: 0;
    padding: 0;
  }
  .image img{
    max-width: 100%;
  }
  .description{
    position: absolute;
    bottom: 50px;
    right: 40px;
  }
  .description.type2{
    left: 25px;
  }
  .content{
    padding-bottom: 65px;
  }
  .sp{
    display: none;
  }
  #itemList{
    margin-bottom: 100px;
  }
  a{
    background: #E05130;
    color: #fff;
    padding: 5px 8px;
    letter-spacing: 0.08em;
    border-radius: 3px;
    margin-left: 10px;
    transition: opacity 500ms ease;
  }
  a:hover{
    text-decoration: none;
    opacity: 0.8;
  }
  a span{
    letter-spacing: -0.04em;
  }
  @media screen and (max-width:920px){
    li{
      font-size: 16px;
    }
    .description{
      right: 10px !important;
      bottom: 10px;
    }
    #itemList{
      margin-bottom: 80px;
    }
  }
  @media screen and (max-width:770px){
    li{
      text-align: right;
    }
    a{
      margin-top: 10px;
      display: inline-block;
      padding: 3px 8px;
      position: relative;
      z-index: 10;
    }
    .description{
      bottom: 0px;
    }
    .sp{
      display: block;
    }
  }
  
  @media screen and (max-width:510px){
    .flex-container{
      display: block;
    }
    .image{
      margin-top: -20px;
    }
    li{
      max-width: 100%;
      text-align: right;
    }
  }
</style>
